import { ReasonCandidate } from '@modules/common/components/ReasonCandidateSuggestion/types';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import { Chip } from '@mui/material';

interface ReasonCandidateSuggestionProps {
  reasonCandidate: ReasonCandidate;
  onClick: (reasonCandidate: ReasonCandidate) => void;
}

export const ReasonCandidateSuggestion = ({
  reasonCandidate,
  onClick,
}: ReasonCandidateSuggestionProps) => {
  return (
    <Chip
      color="primary"
      sx={{
        '.MuiChip-label': {
          color: 'text.secondary',
        },
      }}
      variant="outlined"
      label={reasonCandidate.displayName}
      onClick={() => onClick(reasonCandidate)}
      onDelete={() => onClick(reasonCandidate)}
      deleteIcon={<AddRoundedIcon fontSize="small" />}
    />
  );
};
